import React, { useEffect, useState } from 'react';
import UserDetailWrapper from '../../../components/User/UserDetailWrapper';
import { useGetUser, usePutUser, usePostUser, useSetUserState, useGetUsersEnum } from '../hooks/api/userApi';
import PropTypes from 'prop-types';
import useAppContext from '../../../hooks/context/useAppContext';
import { useIntl } from 'react-intl';
import userRoles from '../../../constants/userRoles';

const UserDetailPage = ({ id }) => {
  const { getUser, data, loading, error } = useGetUser();
  const { putUser, data: putData, loading: putLoading, error: putError } = usePutUser();
  const { postUser, data: postData, loading: postLoading, error: postError } = usePostUser();
  const { getUsersEnum, data: usersData, loading: usersLoading, error: usersError } = useGetUsersEnum();
  const { postUserState, data: postDataState, loading: postLoadingState, error: postErrorState } = useSetUserState();

  const [idSap, setIdSap] = useState('');
  const [firstname, setFirstname] = useState('');
  const [surname, setSurname] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [kamIds, setKamIds] = useState([]);
  const [usersEnum, setUsersEnum] = useState([]);
  const [role, setRole] = useState(userRoles.CUSTOMER);
  const [customers, setCustomers] = useState([]);
  const [language, setLanguage] = useState('CZ');
  const [isNew, setIsNew] = useState(false);
  const [state, setState] = useState(null);
  const { setBreadCrumbs, user: loggedInUser } = useAppContext();
  const intl = useIntl();

  const userTitle = intl.formatMessage({ id: 'app.user' });
  const userNewTitle = intl.formatMessage({ id: 'app.user.new' });

  useEffect(() => {
    if (data) {
      setBreadCrumbs(`${userTitle} - ${data?.firstname} ${data?.surname}`);
    } else if (id === 'new') {
      setBreadCrumbs(`${userNewTitle}`);
    }
  }, [data, setBreadCrumbs, id, userNewTitle, userTitle]);

  const sendUserState = () => {
    const action = state && state === 1 ? 'deactivate' : 'activate';
    postUserState(id, action);
    setState(state === 1 ? 0 : 1);
  };

  const sendHandler = () => {
    const body = {
      firstname: firstname,
      surname: surname,
      email: email.trim(),
      phone: phone,
      role: role,
      idSap: Number(idSap),
      languague: language,
      kamIds: kamIds,
      customers: customers,
    };
    if (id !== 'new') {
      Object.assign(body, { id: id });
      putUser(id, body);
    } else {
      postUser(body);
    }
  };

  const user = {
    id,
    state,
    idSap,
    firstname,
    surname,
    email,
    phone,
    role,
    customers,
    language,
    putData,
    putLoading,
    putError,
    postData,
    postLoading,
    postError,
    postDataState,
    postLoadingState,
    postErrorState,
    kamIds,
    usersEnum,
    usersLoading,
    usersError,
  };

  const handlers = {
    setIdSap,
    setFirstname,
    setSurname,
    setEmail,
    setPhone,
    setRole,
    setLanguage,
    sendHandler,
    sendUserState,
    setKamIds,
    setCustomers,
  };

  useEffect(() => {
    if (id !== 'new') {
      (async () => {
        await getUser(id);
      })();
      setIsNew(false);
    } else {
      setIsNew(true);
    }
  }, [id, getUser]);

  useEffect(() => {
    if (loggedInUser?.role === userRoles.ADMIN || loggedInUser?.role === userRoles.ASM) {
      (async () => {
        await getUsersEnum();
      })();
    }
  }, [getUsersEnum, loggedInUser]);

  useEffect(() => {
    if (usersData) {
      setUsersEnum(usersData);
    }
  }, [usersData]);

  useEffect(() => {
    if (data) {
      setState(data.state);
      setIdSap(data.idSap ?? '');
      setFirstname(data.firstname);
      setSurname(data.surname);
      setEmail(data.email);
      setPhone(data.phone);
      setRole(data.role);
      setLanguage(data.languague);
      setKamIds(data.kamIds);
      setCustomers(data.customers);
    }
  }, [data]);

  return (
    <>
      <UserDetailWrapper id={id} isNew={isNew} loading={loading} error={error} user={user} handlers={handlers} />
    </>
  );
};

UserDetailPage.propTypes = {
  id: PropTypes.any,
};
export default UserDetailPage;
